module.exports = __webpack_public_path__ + "img/index-singlesunglasses.5a52bffa.svg";